export default __webpack_public_path__ + "static/media/crowd-execs.63b874f2.jpg";